import { Logger } from "lib";
import {
  calculateScaledNewDimensions,
  calculateMovedNewDimensions,
  calculateCropMaskScale
} from "views/components/Editor/CropLayer/ImageCropping/ImageCroppingPreview/ImageCroppingPreviewCalculations";
import { getPageHtmlNode } from "views/components/Editor/utils";

const EditorVectorCropOps = {
  startCropMaskResize() {
    Logger.info("Editor.startCropMaskResize called");

    this.setState({
      isCropping: true
    });
  },

  finishCropMaskResize({
    differenceFromInitialOffset,
    dragItem,
    adjustmentOffset
  }) {
    Logger.info("Editor.finishVectorCropMoving called");

    const { zoom, selectedItems } = this.state;

    let vectorElement = this.getElementWithPreview(selectedItems[0].itemId);

    vectorElement = {
      ...vectorElement
      // angle: 0
    };

    const pageId = selectedItems[0].pageId;

    const pageDiv = getPageHtmlNode(pageId);
    const pageOffset = pageDiv.getBoundingClientRect();

    const { mask, height, width, top, left } = calculateCropMaskScale.calc({
      vectorElement,
      dragItem,
      differenceFromInitialOffset,
      pageOffset,
      zoom,
      adjustmentOffset
    });

    const selectedItemUpdated = [
      {
        ...selectedItems[0],
        preview: {
          ...selectedItems[0].preview,
          mask,
          height,
          width,
          top,
          left
        }
      }
    ];

    this.setState({
      isCropping: false,
      selectedItems: selectedItemUpdated
    });
  },

  startVectorCropMode() {
    Logger.info("Editor.startVectorCropMode called");

    // Must update via Redux (same pattern as EditorImageCropOps.startImageCropMode
    // and VectorBarContainer.onStartVectorCropMode). The pre-existing setState
    // path wrote to component-local state, which the mobile actionbar never
    // reads (it consumes context off `this.props.context`, fed from Redux),
    // so the cropVector button on mobile appeared to do nothing.
    const { actionbar, context } = this.props;

    const updatedActionbarState = {
      ...actionbar,
      buttonActive: "crop"
    };
    const updatedContextState = {
      context: {
        ...context,
        isCroppingVector: true
      }
    };

    this.props.updateActionBarState(updatedActionbarState);
    this.props.updateContextState(updatedContextState);
  },

  cancelVectorCropMode() {
    Logger.info("Editor.cancelVectorCropMode called");

    const { actionbar, context, selectedItems } = this.props;

    const selectedItemsUpdated = selectedItems.map(item => ({
      ...item,
      preview: {}
    }));

    const updatedActionbarState = {
      ...actionbar,
      buttonActive: null
    };
    const updatedContextState = {
      context: {
        ...context,
        isCroppingVector: false
      },
      selectedItems: selectedItemsUpdated
    };

    this.props.updateActionBarState(updatedActionbarState);
    this.props.updateContextState(updatedContextState);
  },

  startVectorCropMoving() {
    Logger.info("Editor.startVectorCropMoving called");

    this.setState({
      isCropping: true
    });
  },

  finishVectorCropMoving({ differenceFromInitialOffset }) {
    Logger.info("Editor.finishVectorCropMoving called");

    const { zoom, selectedItems } = this.state;

    let vectorElement = this.getElementWithPreview(selectedItems[0].itemId);

    const { mask } = calculateMovedNewDimensions({
      imageElement: vectorElement,
      differenceFromInitialOffset,
      zoom
    });

    const selectedItemUpdated = [
      {
        ...selectedItems[0],
        preview: {
          ...selectedItems[0].preview,
          mask
        }
      }
    ];
    this.setState({
      isCropping: false,
      selectedItems: selectedItemUpdated
    });
  },

  startVectorCropResizing({ pageId }) {
    Logger.info("Editor.startVectorCropResizing called");

    this.setState({
      isCropping: true
    });
  },

  finishVectorCropResizing({
    handlerInitialPosition,
    anchorPoint,
    differenceFromInitialOffset
  }) {
    Logger.info("Editor.finishVectorCropResizing called");

    const { zoom, selectedItems } = this.state;

    let vectorElement = this.getElementWithPreview(selectedItems[0].itemId);

    vectorElement = {
      ...vectorElement
      // angle: 0
    };

    const pageId = selectedItems[0].pageId;
    const pageDiv = getPageHtmlNode(pageId);

    const pageOffset = pageDiv.getBoundingClientRect();

    const { scale, mask, top, left, height, width } =
      calculateScaledNewDimensions({
        imageElement: vectorElement,
        differenceFromInitialOffset,
        zoom,
        dragItem: { anchorPoint, handlerInitialPosition },
        pageOffset
      });

    const selectedItemUpdated = [
      {
        ...selectedItems[0],
        preview: {
          scale,
          mask,
          top,
          left,
          height,
          width
        }
      }
    ];

    this.setState({
      isCropping: false,
      selectedItems: selectedItemUpdated
    });
  },

  applyCrop() {
    Logger.info("Editor.EditoVectorCropOps.applyCrop  called");

    const { actionbar, designData, selectedItems, context } = this.state;

    const selectedItem = selectedItems[0];

    if (!selectedItem.preview) {
      Logger.info(
        "Editor.EditorVectorCropOps - No changes to be applied, cancelling it"
      );
      this.state.cancelVectorCropMode();
      return;
    }

    const currentItem = designData.elements[selectedItem.itemId];
    const scale = currentItem.scale;
    this.updateStateAndSave({
      actionbar: {
        ...actionbar,
        buttonActive: null
      },
      designData: designData.updateElementsAttribute({
        elementsId: [selectedItem.itemId],
        attributes: { scale, ...selectedItems[0].preview } // always give a scale but prefer preview scale
      }),
      selectedItems: selectedItems.map(item => ({
        ...item,
        preview: {}
      })),
      context: {
        ...context,
        isCroppingVector: false
      }
    });
  }
};

export default EditorVectorCropOps;
